<template>
  <div>
    <article class="message">
      <div class="message-header">
        <p>นโยบายข้อมูลส่วนบุคคล</p>
      </div>
      <div class="message-body">
        การคุ้มครองข้อมูลส่วนบุคคลของท่านคือสิ่งสำคัญในการดำเนินกิจการของบริษัท วี กรุ๊ป ฮอนด้าคาร์ส์ จำกัด (เรียกว่า "บริษัท") ในบางกรณีซึ่งเราไม่สามารถอาศัยเหตุทางกฎหมายอื่นได้ เรามีความจำเป็นต้องขอความยินยอมจากท่านในการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
    <br><br>
    บริษัท จึงใคร่ขอความยินยอมจากท่านในการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของ ท่านเพื่อวัตถุประสงค์ดังต่อไปนี้
    โปรดทำเครื่องหมาย O ในช่องเพื่อให้ความยินยอม
    ความยินยอมเพื่อให้ท่านได้รับข้อมูลข่าวสารซึ่งเป็นประโยชน์และเหมาะสมกับท่าน
    <br><br>
    เพื่อให้ บริษัท วี กรุ๊ป ฮอนด้าคาร์ส์ จำกัด ติดต่อสื่อสาร ให้ข้อมูล นำเสนอสินค้าและบริการที่เลือกสรรมาโดยเฉพาะเพื่อท่านเป็นพิเศษ รวมถึงข้อเสนอ โปรโมชั่น สิทธิพิเศษ ที่อาจตรงใจท่าน เกี่ยวกับผลิตภัณฑ์ สินค้า และบริการ
    หากท่านไม่ให้ความยินยอมหรือถอนความยินยอม บริษัท จะไม่สามารถให้บริการในบางรายการกับท่านซึ่งต้อง อาศัยความยินยอมในการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
    ท่านสามารถถอนความยินยอมเมื่อใดก็ได้ โดยติดต่อไปที่ <a href="https://www.vgrouphonda.com/" target="_blank">https://vgrouphonda.com/</a> อย่างไรก็ดี การถอนความยินยอมของท่านจะไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่านที่ ท่านได้ให้ความยินยอมไปแล้ว
    <br><br>
    ข้าพเจ้าได้อ่านและทำความเข้าใจนโยบายการคุ้มครองข้อมูลส่วนบุคคล
    <a href="https://www.vgrouphonda.com/protection-policy/" target="_blank">https://www.vgrouphonda.com/protection-policy/</a> ซึ่งอธิบายถึงการเก็บรวบรวม ใช้ เป็ดเผย และโอนข้อมูล
    ส่วนบุคคลของท่าน รวมทั้งให้ข้อมูลเกี่ยวกับสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
      </div>
    </article>
  </div>
</template>
<style>
.banner {
  text-align: center;
  background-color: #ededed;
}
.error {
  color: red;
}
.hero-body-login {
  display: flex;
  padding: 3em;
}
</style>
<script>
export default {
  name: 'PDPA',
  beforeCreate () {
  },
  data: () => ({
  }),
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pdpa.vue